<template>
  <div class="steps-bar d-print-none">
    <div class="text mb-2">
      <span>Start</span>
      <span>Fertig</span>
    </div>
    <div class="bar">
      <div
        class="item"
        :class="{ prev: i < current, next: i > current }"
        v-for="i in 10"
        :key="i"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "steps-bar",
  props: {
    current: {
      type: Number,
      default: 1,
    },
  },
};
</script>